import wxShare from '../../assets/js/weChat'
/**
 * @method 这是路由钩子函数
 * @param { Object } to   到哪里去的路由对象
 * @param { Object } from 从哪里来的路由对象
 */
export default (to, from) => {
  // eslint-disable-next-line
  // ga('set', 'page', 'h5:'+to.path)
  // eslint-disable-next-line
  // ga('send', 'pageview')
  document.title = to.meta.title ? to.meta.title : 'Bloom'  // 有名字就改
  if (!to.meta.noNeedShare) {
    if (to.name !== 'Proctor') {
      wxShare({shareTitle: to.meta.title || 'Bloom', shareDes: to.meta.shareDesc, link: to.meta.shareLink, logo: to.meta.shareLogo})
    }
  }

  const u = navigator.userAgent.toLowerCase()
  if (u.indexOf('like mac os x') < 0 || u.match(/MicroMessenger/i) !== 'micromessenger') return
  if (to.path !== global.location.pathname) {
    location.assign(to.fullPath)
  }
}



// WEBPACK FOOTER //
// ./src/router/route-hook/afterEach.js